import React, { Component } from "react";
import { initialIntegrationsData } from "./integartionHelper";

const loyaltyIcons = {
  MLoyal: "🎁",
  EasyRewardz: "💳",
};

class LoyaltyIntegration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      registrationId: props.registrationId || "",
    };

    this.getIcon = this.getIcon.bind(this);
    this.handleConfigureClick = this.handleConfigureClick.bind(this);
  }

  getIcon(name) {
    return loyaltyIcons[name] || "🏷️";
  }

  handleConfigureClick(providerName) {
    // Pass the navigation request to parent component via callback
      this.props.history.push({
      pathname: "/integration/loyalty/credentials-verify",
      state: {
          registrationId: this.state.registrationId,
        gateway: providerName,
      },
    });
  }

  render() {
    const availableProviders = initialIntegrationsData.loyalty.providers || [];

    return (
      <section style={{
        marginBottom: "24px"
      }}>
        <div style={{
          padding: "16px",
          backgroundColor: "white",
          border: "1px solid #E5E7EB",
          borderRadius: "12px",
          marginBottom: "16px"
        }}>
          <h1 style={{
            fontSize: "20px",
            fontWeight: "bold",
            color: "#374151"
          }}>
            {initialIntegrationsData.loyalty.title}
          </h1>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
          gap: "24px"
        }}>
          {availableProviders.map(function(provider) {
            return (
              <div
                key={provider.name}
                style={{
                  backgroundColor: "white",
                  border: "1px solid #E5E7EB",
                  borderRadius: "16px",
                  padding: "24px",
                  transition: "all 0.3s ease-in-out",
                  position: "relative",
                  overflow: "hidden",
                  height: "fit-content"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(to right, #F472B6, #E11D48)"
                }}></div>

                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  marginBottom: "24px"
                }}>
                  <div style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "24px",
                    background: "linear-gradient(to bottom right, #F8FAFC, #F1F5F9)",
                    border: "2px solid #E2E8F0"
                  }}>
                    {this.getIcon(provider.name)}
                  </div>
                  <div>
                    <h3 style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: "#111827"
                    }}>
                      {provider.name}
                    </h3>
                  </div>
                </div>

                <button
                  onClick={() => this.handleConfigureClick(provider.name)}
                  style={{
                    width: "100%",
                    backgroundColor: "white",
                    color: "#2563EB",
                    border: "1px solid #2563EB",
                    borderRadius: "8px",
                    padding: "10px 16px",
                    fontWeight: "500",
                    transition: "background-color 0.2s",
                    boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    cursor: "pointer"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#EFF6FF";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "white";
                  }}
                >
                  <span>⚙️</span> Setup
                </button>
              </div>
            );
          }, this)}
        </div>
      </section>
    );
  }
}

export default LoyaltyIntegration;